import React from "react";
import NextLink from "next/link";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";
import { useTranslation } from "next-i18next";

import Container from "../Container";

const RequestADemo = ({ title }) => {
  const theme = useTheme();
  const { t } = useTranslation("common");

  return (
    <Box bgcolor={theme.palette.primary.dark}>
      <Container sx={{ textAlign: "center" }}>
        <Typography variant="h4" component="h3" color="white" fontWeight={800} mb={6}>
          {title || t("request_a_demo.title")}
        </Typography>
        <NextLink href="/demo" passHref>
          <Button
            component={"a"}
            variant="contained"
            color="alternate"
            size="large"
            sx={{
              display: "inline-block",
            }}
          >
            {t("request_a_demo.cta")}
          </Button>
        </NextLink>
      </Container>
    </Box>
  );
};

export default RequestADemo;
